/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * TODO:
 * Schedule appointment for review.
 */

import { API } from 'api/config'
import axios from 'axios'
import {
	BannerMyOrganizationItem,
	PatchMyOrganizationResponse,
	ProfileImageMyOrganizationItem,
	TabMyOrganizationItem,
	UpdateImageBody
} from 'interfaces'
import { captureErrorSentry, SentryEvents, SentrySections } from 'utils/sentry'

export const postMyOrganizationTab = async (
	organizationId: number,
	data: TabMyOrganizationItem[]
): Promise<PatchMyOrganizationResponse | null> => {
	let res = null as PatchMyOrganizationResponse | null
	const body = {
		cards: data
	}
	await API()
		.post(`/organizations/admin/${organizationId}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				captureErrorSentry({
					section: SentrySections.MY_ORGANIZATION,
					event: SentryEvents.POST_MY_ORGANIZATION_TAB_ERROR,
					error,
					extra: {
						payload: body,
						organizationId
					}
				})
				console.error(error)
			}
		)
	return res
}

export const postMyOrganizationProfileImage = async (
	organizationID: number,
	data: ProfileImageMyOrganizationItem
): Promise<PatchMyOrganizationResponse | null> => {
	let res = null as PatchMyOrganizationResponse | null
	const timeStamp = '?timestamp='

	let profileImage

	if (data.cover) {
		profileImage = data.cover.includes(timeStamp) && data.cover.split(timeStamp)
	}
	const body = {
		profile_image: profileImage
			? `${profileImage[0]}${timeStamp}${Date.now()}`
			: data.cover,
		icon_image_url: data.icon,
		primary_color: data.primary_color,
		secondary_color: data.secondary_color,
		third_color: data.third_color,
		fourth_color: data.fourth_color
	}
	await API()
		.post(`/organizations/profile_image/${organizationID}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.error(error)
			}
		)
	return res
}

export const postMyOrganizationBanner = async (
	organizationID: string,
	data: BannerMyOrganizationItem[]
): Promise<PatchMyOrganizationResponse | null> => {
	let res = null as PatchMyOrganizationResponse | null
	const body = {
		banners: data
	}
	await API()
		.post(`/organizations/banners/${organizationID}`, body)
		.then(
			async response => {
				res = response.data
			},
			error => {
				console.error(error)
			}
		)
	return res
}

export const getFormData = (object: any): any =>
	Object.keys(object).reduce((formData, key) => {
		formData.append(key, object[key])
		return formData
	}, new FormData())

export const updateImage = async (
	url: string,
	body: UpdateImageBody
): Promise<void> => {
	const formdata = getFormData(body)
	// No Content-Type header is passed intentionally: Axios sets multipart/form-data
	// with the correct boundary automatically when the body is FormData.
	await axios.post(url, formdata)
}
